export default __webpack_public_path__ + "static/media/DSC_0532.c71d22ce.jpg";